import { useState } from 'react';
import { Grid, Paper, Tab, Tabs } from '@mui/material';
import { SiTrackPage } from '../../../components/si-track-page';
import { TabPanel } from '../../../components/tab-panel';
import { ServiceTab } from './service-tab';
import { ServicesMunicipalityMappingTab } from './services-municipality-mapping-tab';

const styling = {
  paperStyle: { borderRadius: '20px' },
};

export const ServicesPage = () => {
  const [tabValue, setTabValue] = useState('service');

  const handleTabsChange = (_event: any, newValue: any) => {
    setTabValue(newValue);
  };

  return (
    <SiTrackPage title="Services">
      <Paper elevation={0} style={styling.paperStyle}>
        <Grid style={{ paddingBottom: '8px' }}>
          <Tabs value={tabValue} onChange={handleTabsChange} aria-label="wrapped label tabs example">
            <Tab value="service" label="Services" />
            <Tab value="municipalityMapping" label="Services Municipality Mapping" />
          </Tabs>
          <TabPanel selectedValue={tabValue} value="service">
            <ServiceTab />
          </TabPanel>
          <TabPanel selectedValue={tabValue} value="municipalityMapping">
            <ServicesMunicipalityMappingTab />
          </TabPanel>
        </Grid>
      </Paper>
    </SiTrackPage>
  );
};
